
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_PROCESS_MESSAGE_IS_MALFORMED,
	WS_REQUEST_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import { fromDTO as mapper } from './mappers/incidentServiceMapper';
import { publishAndAwait } from '../../../app/coreSlice';

const invoiceIncident = async ({incidentCode, customerCode}) => {

	if ('undefined' === typeof incidentCode && 'undefined' === typeof customerCode) {
		throw errorFactory(WS_REQUEST_IS_MALFORMED);
	};

	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'INVOICE',
			subType: 'CREATE_INCIDENT_INVOICE',
			message: {
				incidentCode,
				customerCode,
			},
		},
	});

	const { processMessage, error } = request.response;

	if (!processMessage) {
		throw errorFactory(WS_PROCESS_MESSAGE_IS_MALFORMED);
	};

	if (error) {

		const {
			description,
			code,
			tag,
		} = processMessage;

		throw new NGError({
			message: description,
			code,
			tag,
		});
	};

	return mapper(processMessage);
};

export default invoiceIncident;